const sideMenu = [
  {
    id: "purchase_list",
    label: "Purchase Management",
    href: "/app/purchase",
    permissions: [1, 2]
  },
  {
    id: "userlist",
    label: "User Management",
    href: "/app/users",
    permissions: [1]
  }
];

export default sideMenu;
